import React from "react";
import KickImage from 'Reuseables/KickImage';
import { Row, Col, Modal } from "reactstrap";
import CloseIcon from "../../../../../images/close-button-black.png";

type Props = {
  isOpenModalInfo: boolean;
  onToggle: () => any;
};

const UserBalanceInfoModal: React.FC<Props> = ({
  isOpenModalInfo,
  onToggle,
}) => {
  return (
    <Modal
      isOpen={isOpenModalInfo}
      toggle={onToggle}
      modalClassName="modal-seller-credit-info"
    >
      <div onClick={onToggle} className="close-wrapper">
        <KickImage src={CloseIcon} />
      </div>
      <Row>
        <Col>
          <p>What is Kick Credit?</p>
          <p>
            Kick Credit is a monetary balance you get from top-ups and refunds.
            There is no cash out fee.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>What is Seller Credit?</p>
          <p>
            Seller Balance is a monetary balance from your sales. It can also be
            used to purchase anything in Kick Avenue. Cash out fee applies.
          </p>
        </Col>
      </Row>
    </Modal>
  );
};

export default UserBalanceInfoModal;
